/*
 * /[?(error=user_must_log_in|message=account_deletion_started)]
 */

$(function() {
    // show alerts

    const params = new URLSearchParams(window.location.search);

    if (params.get("error") === "user_must_log_in") {
        $("#userMustLogInAlert").show();
    }
    if (params.get("message") === "account_deletion_started") {
        $("#accountDeletionStartedAlert").show();
    }

    // cookie consent and analytics

    if (getCookie("cookie_consent") === "true") {
        enableAnalytics();
    } else {
        $("#cookieConsentBox").show();
    }

    $("#cookieConsentButton").on("click", function() {
        // set persistent cookie for 1 year
        document.cookie = "cookie_consent=true; Path=/; Max-Age=31536000; Secure; SameSite=Lax";
        // close box
        $("#cookieConsentBox").hide();
        // execute 3rd parties
        enableAnalytics();
    });

    // sign up and log in

    // redirect to dashboard if there is an active session
    $.getJSON("/api/bff/session")
    .done(function(serverData) {
        if (serverData.active_session) {
            // redirect to dashboard
            window.location.replace("/dashboard");
        } else {
            // enable sign up and log in buttons
            $("#signUpButton").prop("disabled", false);
            $("#logInButton").prop("disabled", false);
        }
    });

    let stravaClientId;

    $("#signUpButton").on("click", function() {
        $(this).prop("disabled", true);

        // check again if there is an active session
        $.getJSON("/api/bff/session")
        .done(function(serverData) {
            if (serverData.active_session) {
                // redirect to dashboard
                window.location.replace("/dashboard");
            } else {
                // store stravaClientId
                stravaClientId = serverData.strava_client_id;
                // open sign up modal
                new bootstrap.Modal(document.getElementById("signUpModal"), {}).show();
                $("#signUpButton").prop("disabled", false);
            }
        });
    });

    $("#signUpConnectWithStravaButton").on("click", function() {
        const stravaUrl =
            "https://www.strava.com/oauth/authorize?" +
            $.param({
                client_id: stravaClientId,
                redirect_uri: "https://" + window.location.hostname + "/strava-landing",
                response_type: "code",
                scope: "profile:read_all,activity:read_all",
                state: buildStravaState($("#signUpPersistentSessionInput").is(":checked"))
            });
        window.location.assign(stravaUrl);
    });

    $("#logInButton").on("click", function() {
        $(this).prop("disabled", true);

        // check again if there is an active session
        $.getJSON("/api/bff/session")
        .done(function(serverData) {
            if (serverData.active_session) {
                // redirect to dashboard
                window.location.replace("/dashboard");
            } else {
                // store stravaClientId
                stravaClientId = serverData.strava_client_id;
                // open log in modal
                new bootstrap.Modal(document.getElementById("logInModal"), {}).show();
                $("#logInButton").prop("disabled", false);
            }
        });
    });

    $("#logInConnectWithStravaButton").on("click", function() {
        const stravaUrl =
            "https://www.strava.com/oauth/authorize?" +
            $.param({
                client_id: stravaClientId,
                redirect_uri: "https://" + window.location.hostname + "/strava-landing",
                response_type: "code",
                scope: "profile:read_all,activity:read_all",
                state: buildStravaState($("#logInPersistentSessionInput").is(":checked"))
            });
        window.location.assign(stravaUrl);
    });
});

function getCookie(name) {
    if (!document.cookie) {
        return null;
    }

    // cookie key/value pairs may be separated by semicolon or semicolon space
    // there may be whitespace at the beginning and end of cookie string
    const cookies = document.cookie.split(";");

    const prefix = name + '=';

    const pair = cookies.find(element => element.trim().startsWith(prefix));
    if (!pair) {
        return null;
    }

    // strip off key and '='
    const value = pair.trim().substring(prefix.length);

    return value;
}

function enableAnalytics() {
    // Google Analytics
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
		'ad_personalization': 'granted',
        'analytics_storage': 'granted'
    });
    // Facebook Pixel
    fbq('consent', 'grant');
}

function buildStravaState(persistentCookie) {
    return new URLSearchParams({
        persistent_cookie: persistentCookie ? "true" : "false",
        ts: new Date().toJSON()
    }).toString();
}
